import Loadable from 'react-loadable'
import Loading from '../../components/Loading'

export const UserRegister = Loadable({
  loader: () => import('./containers/Register'),
  loading: Loading
})



// WEBPACK FOOTER //
// ./src/containers/UserRegister/index.js